import { Snackbar } from "@material-ui/core";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import React from "react";
import { useAppState } from "../../../common/appState";
import { useDelayedState } from "../../../common/hooks/useDelayedState";
import { zIndex } from "../../zApps/Layout/zIndex";
import { hideSnackbar } from "./functions";

function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const transitionDuration = 500;

export const GlobalSnackbar: React.FC = () => {
    const [snackbarState] = useAppState("snackbarState");

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }
        hideSnackbar();
    };

    const { delayedState } = useDelayedState(
        snackbarState,
        s => s.open,
        transitionDuration
    );

    return (
        <Snackbar
            open={snackbarState.open}
            autoHideDuration={
                delayedState.open ? delayedState.autoHideDuration : undefined
            }
            onClose={handleClose}
            transitionDuration={transitionDuration}
            style={{ zIndex: zIndex.snackbar }}
        >
            <Alert
                onClose={handleClose}
                severity={delayedState.open ? delayedState.severity : undefined}
            >
                {delayedState.open && delayedState.message}
            </Alert>
        </Snackbar>
    );
};
